'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('end_user_reconfirm', {
    url: '/user_reconfirm',
    template: '<end-user-reconfirm></end-user-reconfirm>'
  })
}



// WEBPACK FOOTER //
// ./public/dev/app/end_user_reconfirm/end_user_reconfirm.routes.js